import { render, staticRenderFns } from "./liveBroadcastParametersList.vue?vue&type=template&id=63097386"
import script from "./liveBroadcastParametersList.vue?vue&type=script&lang=js"
export * from "./liveBroadcastParametersList.vue?vue&type=script&lang=js"
import style0 from "./liveBroadcastParametersList.vue?vue&type=style&index=0&id=63097386&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports